import { defer } from 'react-router-dom'

import { logger } from '$utils'

import { isAppStateReady } from 'src/state/store'

import useMenusStore from './store'

async function menusLoader() {
  logger.debug('[loader] About to await AppState being ready in Menus loader')
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Menus loader')

  const getMenus = useMenusStore.getState().getMenus()

  return defer({
    data: Promise.all([getMenus])
      .then(([menus]) => ({ menus }))
      .catch((error) => {
        logger.error('Menus Promise.all error', error)
        return { menus: [] }
      }),
  })
}

export default menusLoader
